import { defHttp } from '@/utils/request';
import { StatisticsModel, PersonalBasicData, PersonalEvaluateModel } from './model/statisticsModel';
// 基础情况
export const getPersonalBasic = (juryId, openId) =>
  defHttp.get<ResponseData<PersonalBasicData>>({
    url: '/countReport/personalBasic',
    params: {
      juryId,
      openId,
    },
  });

// 个人能力评价报告
export const getPersonalEvaluate = (juryId) =>
  defHttp.get<ListData<PersonalEvaluateModel>>({
    url: '/countReport/personalEvaluate',
    params: {
      juryId,
    },
  });

// 个人成果情况
export const getPersonalResult = (juryId) =>
  defHttp.get<ResponseData<PersonalBasicData>>({
    url: '/countReport/personalResult',
    params: {
      juryId,
    },
  });

// 个人成果情况
export const getPersonalEdu = (juryId) =>
  defHttp.get<ResponseData<StatisticsModel>>({
    url: '/countReport/edu',
    params: {
      juryId,
    },
  });

// 著作
export const getPersonalBook = (juryId) =>
  defHttp.get<ResponseData<StatisticsModel>>({
    url: '/countReport/book',
    params: {
      juryId,
    },
  });

// 论文
export const getPersonalThesis = (juryId) =>
  defHttp.get<ResponseData<StatisticsModel>>({
    url: '/countReport/thesis',
    params: {
      juryId,
    },
  });

// 表彰奖励
export const getPersonalReward = (juryId) =>
  defHttp.get<ResponseData<StatisticsModel>>({
    url: '/countReport/reward',
    params: {
      juryId,
    },
  });

// 知识产权
export const getPersonalPatent = (juryId) =>
  defHttp.get<ResponseData<StatisticsModel>>({
    url: '/countReport/patent',
    params: {
      juryId,
    },
  });

// 知识产权
export const getPersonalProject = (juryId) =>
  defHttp.get<ResponseData<StatisticsModel>>({
    url: '/countReport/project',
    params: {
      juryId,
    },
  });

// 年度考核
export const getPersonalYearCheck = (juryId) =>
  defHttp.get<ResponseData<StatisticsModel>>({
    url: '/countReport/yearCheck',
    params: {
      juryId,
    },
  });

interface PayData {
  timeStamp: string;
  prepayId: string;
  paySign: string;
  package: string;
  appId: string;
  signType: 'SHA1' | 'MD5';
  nonceStr: string;
}

export const payStatistcs = (openId, juryId) =>
  defHttp.get<ResponseData<PayData>>(
    {
      url: '/wxpay/orders',
      params: {
        openId,
        juryId,
      },
    },
    {
      withToken: false,
    },
  );
